<template>
  <div >
    <Index />
    <Work />
    <Content />
    <Production />
    <Sense />
    <!-- <iframe src="https://miguan.360.cn/#friend" frameborder="0"></iframe> -->
    <SjFooter />
  </div>
</template>
<script>
import Index from "./views/index.vue";
import Work from "./views/Work.vue";
import Content from "./views/Content.vue";
import Production from "./views/Production";
import Sense from "./views/Sense";
import SjFooter from "./views/Footer";

// import Friend from './components/Friend.vue'

export default {
  name: "App",
  components: {
    Index,
    Content,
    Work,
    Production,
    Sense,
    SjFooter,
    // Friend
  }
};
</script>
<style>
iframe{
  width: 100%;
  height: 300px;
}
</style>

